import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

export default function QuizCustomQuestion({
  formState,
  handleNextClick,
  onChange,
  questionIdx,
  subtitle,
  title,
  isValid,
  onSubmit
}) {
  const inputName = `custom_application_answers_attributes.${questionIdx}.answer_text`;
  const answer = get(formState, inputName, '');

  return (
    <div className="AdoptionApplicationQuizCustomQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid={isValid}
        title={title}
        subtitle={subtitle}
        onSubmit={onSubmit}
      >
        <FullPageQuizTextInput
          Tag="textarea"
          name={inputName}
          onChange={onChange}
          value={answer || ''}
        />
      </FullPageQuizQuestion>
    </div>
  );
}

QuizCustomQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  questionIdx: PropTypes.number.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func
};

QuizCustomQuestion.defaultProps = {
  subtitle: null,
  onSubmit: null
};
